import { createDecorator } from 'trtc-js-sdk-core/src/plugin';
import { ProcessHandler } from 'trtc-js-sdk-core/src/utils/decorators/middleware';
import { doValidate } from '../common/validate';
import RtcError from '../common/rtc-error';
import { ErrorCode, ErrorCodeDictionary } from '../common/error-code';
import { isFunction } from 'trtc-js-sdk-core/src/utils/utils';

import { PluginStartOptionsMap, PluginUpdateOptionsMap, PluginStopOptionsMap } from '../type';
import type TRTC from '../main';
type PluginOptionsMap<T extends 'start' | 'update' | 'stop'> = T extends 'start' ? PluginStartOptionsMap : T extends 'update' ? PluginUpdateOptionsMap : PluginStopOptionsMap;
export const validatePlugin = <T extends 'start' | 'update' | 'stop', Name extends keyof PluginOptionsMap<T>>(method: T) => createDecorator((next: ProcessHandler, fnName: string) => async function (this: TRTC, name: Name, options: PluginOptionsMap<T>[Name]) {
  const plugin = this._plugins.get(name);
  if (!plugin) {
    this._log.error(`plugin ${String(name)} is not found`);
    throw new RtcError({
      code: ErrorCode.OPERATION_ABORT,
      message: `plugin ${String(name)} is not found`,
      fnName
    });
  }
  if (isFunction(plugin.constructor.isSupported) && !plugin.constructor.isSupported()) {
    this._log.error(`plugin ${String(name)} is not supported`);
    throw new RtcError({
      code: ErrorCode.ENV_NOT_SUPPORTED,
      message: `plugin ${String(name)} is not supported`,
      extraCode: ErrorCodeDictionary.NOT_SUPPORTED_PLUGIN,
      fnName
    });
  }
  doValidate.call(this, plugin.getValidateRule(method), [options], fnName, 'TRTC');
  return next.call(this, plugin, options);
});
